import {
  BulkBudgetAssignmentAssignment,
  BulkRewardFailedEmails,
  CelebrationTag,
  User,
  ValidateBulkBudgetAssignmentError
} from "@irati/types"
import {CSVErrors} from "../../enums/CsvErrors"
import {DistributeRewardImportType, DistributeRewardRecipient} from "../../enums/DistributeRewardTypes"

export interface UserRecognition {
  companyValues?: string[]
  message: string
  userIds: string[]
  teamIds: string[]
  isPrivate: boolean
  share: {label: string; value: string}
  occasionId?: string
}

export const steps = ["recipients", "message", "confirm"] as const

export type Step = (typeof steps)[number]

export interface DistributeRewardState {
  step: Step
  pointsPerUser: number
  message: string
  destinationUsers: User[]
  userEmails: string[]
  recipientType: DistributeRewardRecipient
  rewardImportType: DistributeRewardImportType
  recognition: UserRecognition
  bulkRewardState: {
    failedEmails: BulkRewardFailedEmails[]
    uuid: string | null
    csvError: CSVErrors | null
  }
  bulkBudgetAssignmentState: {
    assignments: BulkBudgetAssignmentAssignment[]
    totalToPay: number
    failedEmails?: ValidateBulkBudgetAssignmentError[]
  }
  modalErrorState: {
    title: string
    content: string
    buttonText: string
    show: boolean
  }
  budgetCategory?: string
  checkUnassigned: boolean
  schedule?: {
    utc?: string
    timezone?: string
    isScheduled?: boolean
  }
  errors?: {
    noRecipientType?: boolean
  }
  rewardTemplate?: CelebrationTag | null
  rewardTemplateTitle?: string
  modalConfirmIsShown: boolean
}
export type DistributeRewardActionTypes =
  | {
      type: "SWITCH_RECIPIENT"
      payload: {recipientType: DistributeRewardRecipient}
    }
  | {
      type: "UPDATE_RECIPIENTS"
      payload: {recipientsList: User[] | string[]}
    }
  | {
      type: "SWITCH_IMPORT_TYPE"
      payload: {importType: DistributeRewardImportType}
    }
  | {
      type: "SET_USER_POINTS"
      payload: {userPoints: string}
    }
  | {
      type: "SET_MESSAGE"
      payload: {message: string}
    }
  | {
      type: "SET_RECOGNITION"
      payload: {
        recognition: Partial<UserRecognition>
      }
    }
  | {
      type: "SET_MODAL_ERROR_STATE"
      payload: DistributeRewardState["modalErrorState"]
    }
  | {
      type: "SET_BULK_REWARD_STATE"
      payload: DistributeRewardState["bulkRewardState"]
    }
  | {type: "ON_ACCEPT_EMAIL_ERRORS"}
  | {type: "ON_REJECT_EMAIL_ERRORS"}
  | {
      type: "SET_BUDGET_CATEGORY"
      payload: {budgetCategory?: string}
    }
  | {
      type: "SET_CHECK_UNASSIGNED"
      payload: {checkUnassigned: boolean}
    }
  | {
      type: "SET_SCHEDULE"
      payload: NonNullable<DistributeRewardState["schedule"]>
    }
  | {
      type: "SET_CONFIRMATION_MODAL"
      payload: {
        modalConfirmIsShown: boolean
      }
    }
  | {
      type: "SET_TEMPLATE"
      payload: {
        tag: CelebrationTag
      }
    }
  | {
      type: "SET_REWARD_TEMPLATE_TITLE"
      payload: {
        title?: string
      }
    }
  | {
      type: "SET_RECIPIENT_ERROR"
      payload: boolean
    }
  | {
      type: "SET_STEP"
      payload: DistributeRewardState["step"]
    }
  | {
      type: "SET_BULK_BUDGET_ASSIGNMENT_STATE"
      payload: DistributeRewardState["bulkBudgetAssignmentState"]
    }
